import { LoginRepsonseTypes } from '@typedef/components/Login/login.types';
import { UPDATE_PROFILE_ACTION_TYPES } from './modules/actionTypes';

export const updateProfileAction = (payload: LoginRepsonseTypes) => ({
  type: UPDATE_PROFILE_ACTION_TYPES,
  payload,
});

export type ProfileActionTypes = ReturnType<typeof updateProfileAction>;
